import React from 'react';
import {FileComponent} from 'components/files/FilesList';
import api from 'controllers/raymanAPI';
import HiddenFileInput from 'components/files/HiddenFileInput';
import {Add, Delete} from '@material-ui/icons';
import {Button} from 'components/core';
import clsx from 'clsx';
import {makeStyles} from '@material-ui/core/styles';

const styles = makeStyles((theme) => ({
    media: {
        maxWidth: "100%",
        width: "100%",
        height: "auto",
        borderRadius: 8
    },
    
  }), {name: "StepsDialog"});

export default function TemplateFieldView({classes, field})
{
    const apiEndpoint = api.filehosting;
    const templateClasses = styles();
    let value;
    switch(field.dataType.typeID)
    {
        case 5: //picture
        value = <img alt={field.name} src={apiEndpoint.fileDownloadURL(field.value)} className={templateClasses.media}/>
        break;
        case 6: // video
            value = <video src={apiEndpoint.fileDownloadURL(field.value)} controls="true" className={templateClasses.media}/>
        break;
        case 7: // file
            value = <SmartFileComponent fileID={field.value}/>
        break;
        default:
            value = field.value;
        break;
    }
    return <div className={classes.infoPair} key={field.fieldID}>
          <div className={classes.infoHeader}>{field.name}</div>
          <div className={classes.infoField}>{value}</div>
        </div>
}


export function GetAsFormField(field)
{
    switch(field.dataType.typeID)
    {
        case 5: // picture
        case 6: // video
        case 7: // file
        return {
            type: "custom",
            label: field.name,
            value: field.value,
            managed: true,
            id: "templateField."+field.fieldID,
            content: function({...formProps}) { return <TemplateFileComponent dataType={field.dataType.typeID} {...formProps} /> }
        }
        default:
            return {
                type: "text",
                label: field.name,
                value: field.value,
                placeholder: field.placeholder,
                mandatory: false,
                id: "templateField."+field.fieldID
            }
    }
}

function SmartFileComponent({fileID})
{
    const apiEndpoint = api.filehosting;
    const [file, setFile] = React.useState(null);
    const [loading, setLoading] = React.useState(true);

    const parseFile = React.useCallback(function parseFile(tmpFile)
    {
        return {...tmpFile, id: tmpFile.fileID, src: apiEndpoint.fileDownloadURL(tmpFile.fileID)};
    }, [apiEndpoint]);
    

    React.useEffect(function updateFile() {

        async function getFile(fileID)
        {
            let response = await apiEndpoint.getSingle(fileID);
            if(!response.ok)
            {
                setLoading(false);
                return null;
            }
            else
            {
                let tmpFile = await response.json();
                let newFile = parseFile(tmpFile);
                setLoading(false);
                setFile(newFile);
            }
        }
        if(!fileID)
        {
            setLoading(false);
            return;
        }
        setLoading(true);
        getFile(fileID);
    }, [fileID, apiEndpoint, parseFile]);

    if(loading || !file) return null;

    return <FileComponent file={file}/>
}

function TemplateFileComponent({value, onChange, placeholder, dataType})
{
    const apiEndpoint = api.filehosting;
    const [file, setFile] = React.useState(null);
    const [loading, setLoading] = React.useState(true);
    const fileInput = React.useRef();

    const inputAcceptTypes = {
        5: "image/*",
        6: "video/*",
        7: "*"
    }

    const parseFile = React.useCallback(function parseFile(tmpFile)
    {
        return {...tmpFile, id: tmpFile.fileID, src: apiEndpoint.fileDownloadURL(tmpFile.fileID)};
    }, [apiEndpoint]);
    

    React.useEffect(function updateFile() {

        async function getFile(fileID)
        {
            let response = await apiEndpoint.getSingle(fileID);
            if(!response.ok)
            {
                setLoading(false);
                return null;
            }
            else
            {
                let tmpFile = await response.json();
                let newFile = parseFile(tmpFile);
                setLoading(false);
                setFile(newFile);
            }
        }
        if(!value)
        {
            setLoading(false);
            return;
        }
        console.log("value updated", value);
        setLoading(true);
        getFile(value);
    }, [value, apiEndpoint, parseFile]);

    const uploadFile = React.useCallback(async () => {
        fileInput.current.click();
    }, [fileInput]);

    const removeFile = React.useCallback(async () => {
        if(!value) return;
        let response = await apiEndpoint.deleteSingle(value);
        if(response.ok)
        {
            setFile(null);
            onChange("");
        }
    }, [apiEndpoint, onChange, value]);

    const onUploadFile = (fileData) => {
        let newFile = parseFile(fileData);
        onChange(newFile.fileID);
    }

    if(loading) return null;

    if(file === null)
    {
        return <>
        <HiddenFileInput ref={fileInput} apiFileEndpoint={apiEndpoint} apiRequestParams={[]} onUpload={(fileData) => onUploadFile(fileData)} inputAccept={inputAcceptTypes[dataType]} />
        <Button fullWidth={false} color="primary" onClick={()=>uploadFile()}><Add />Subir Archivo</Button>
        </>
    }
     
    return <><FileComponent file={file}/>
    <Button fullWidth={false} color="error" onClick={()=>removeFile()}><Delete />Borrar</Button>
    </>
}